package com.artvending.warden

import org.jetbrains.compose.web.css.px

class JsSettings : MySettings() {
	val space = MySettings.space.px
	val bigSpace = MySettings.bigSpace.px
	val smallSpace = MySettings.smallSpace.px
	val imageSize = MySettings.imageSize.px
	val opacityGray = MySettings.opacityGray.toColor()
	val opacityLightGray = MySettings.opacityLightGray.toColor()
	val secondaryContainerColor = MySettings.secondaryContainerColor.toColor()
	val buttonColor1 = MySettings.buttonColor1.toColor()
	val buttonColor2 = MySettings.buttonColor2.toColor()
	val buttonColor3 = MySettings.buttonColor3.toColor()
	
	val displayFontClass = "md-typescale-display-medium"
	val headlineFontClass = "md-typescale-headline-medium"
	val titleFontClass = "md-typescale-title-medium"
	val bodyFontClass = "md-typescale-body-medium"
	val labelFontClass = "md-typescale-label-medium"
	val PAGE_WIDTH = 370
	val NEW_GUI = true
}